import React, { useRef, useState,useEffect } from "react";
import PropTypes from "prop-types";
import { uploadVideoWithName, getVideoName } from "../../core/img/imagewithbasebath";

const ImageToVideoCanvas =  ({ imageUrls, onVideoGenerated }) => {
  const [images, setImages] = useState([]);
  const [videoUrl, setVideoUrl] = useState(null);
  const canvasRef = useRef(null);//
  const mediaRecorderRef = useRef(null);
  const chunksRef = useRef([]);
  const audioContextRef = useRef(new (window.AudioContext || window.webkitAudioContext)());


    useEffect(() => {
      const fetchImages = async () => {
        if (imageUrls.length === 0) return;
      
        try {
          const fetchedImages = await Promise.all(
            imageUrls.map(async (url) => {
              console.log("url.source",url.source);
              const response = await fetch(url.source, {
                method: "GET",
                referrerPolicy: "strict-origin-when-cross-origin",
                headers: {
                  "Content-Type": "application/json",
                },
              });
              if (!response.ok) throw new Error(`Failed to fetch ${url.source}`);
      
              const blob = await response.blob();
              const reader = new FileReader();
      
              return new Promise((resolve) => {
                reader.onloadend = () => resolve(reader.result); // Convert to Base64
                reader.readAsDataURL(blob);
              });
            })
          );
      
          setImages(fetchedImages);
        } catch (error) {
          console.error("Error fetching images:", error);
        }
      };
      
      
  
      fetchImages();
    }, [imageUrls]);
  
    useEffect(() => {
      if (images.length > 0) {
        generateVideo();
      }
    }, [images]);

    // useEffect(() => {
    //   if (imageUrls.length > 0) {
    //     const fetchedImages = await Promise.all(
    //       imageUrls.map(async (url) => {
    //         const response = await fetch(url);
    //         const blob = await response.blob();
    //         return new File([blob], url.split("/").pop(), { type: blob.type });
    //       })
    //     );
    //     setImages(fetchedImages);
    //   }
    // }, [imageUrls]);


   
  // };
  
  const fetchAndDecodeAudio = async () => {
    const response = await fetch(
      "https://cdn.uppbeat.io/audio-files/ca51760c641519bcff2c32cdf8e83fff/3900208d9f7d807c9ca241fc9e47615f/83a1343e5b8e80fab1e119b15772ee1c/STREAMING-blue-sea-swoop-main-version-18177-01-14.mp3"
    );
    const arrayBuffer = await response.arrayBuffer();
    return audioContextRef.current.decodeAudioData(arrayBuffer);
  };

  const generateVideo = async () => {
    if (images.length === 0) {
      alert("Please select images first.");
      return;
    }

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    // Set canvas size
    canvas.width = 1280;
    canvas.height = 720;

    // Capture the canvas stream
    const videoStream = canvas.captureStream();

    // Load and decode audio
    const audioBuffer = await fetchAndDecodeAudio();
    const source = audioContextRef.current.createBufferSource();
    source.buffer = audioBuffer;

    // Create an audio stream
    const destination = audioContextRef.current.createMediaStreamDestination();
    source.connect(destination);
    source.start();

    // Combine video and audio into one stream
    const combinedStream = new MediaStream([
      ...videoStream.getTracks(),
      ...destination.stream.getTracks(),
    ]);

    const recorder = new MediaRecorder(combinedStream);
    mediaRecorderRef.current = recorder;
    chunksRef.current = [];

    recorder.ondataavailable = (e) => chunksRef.current.push(e.data);
    recorder.onstop = async() => {
      const blob = new Blob(chunksRef.current, { type: "video/mp4" });

      if (blob) {
            
        const name =  getVideoName()
        //uniqueString({length: 10, userId: '', tenantId: '', name: "Video.mp4", platform: '', app: 'web', module: 'sooqista'})
 
        blob.name = "Video.mp4";
        let url = await uploadVideoWithName(blob,name);
        console.log("Final url",url);
        setVideoUrl(url);
        onVideoGenerated(url);
      }
      // const url = URL.createObjectURL(blob);
      // setVideoUrl(url);
      // onVideoGenerated(url);
    };

    recorder.start();

    for (const img of images) {
      const image = new Image();
      image.src = URL.createObjectURL(img);
      await new Promise((resolve) => {
        image.onload = () => {
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
          setTimeout(resolve, 1000);
        };
      });
    }

    recorder.stop();
  };

  return (
    <div className="container mt-4">
      <h2 className="mb-3">Generate Video from Images</h2>
      {/* <input type="file" multiple accept="image/*" onChange={handleFileChange} className="form-control mb-3" /> */}
      <button className="btn btn-primary" onClick={generateVideo}>Generate Video</button>

      <canvas ref={canvasRef} style={{ display: "none" }}></canvas>

      {videoUrl && (
        <div className="mt-4">
          <h4>Generated Video:</h4>
          <video controls width="640" src={videoUrl}></video>
          <a href={videoUrl} download="generated-video.mp4" className="btn btn-success mt-2">Download Video</a>
        </div>
      )}
    </div>
  );
};

ImageToVideoCanvas.propTypes = {
  imageUrls: PropTypes.array.isRequired,
  onVideoGenerated: PropTypes.func.isRequired,
};

export default ImageToVideoCanvas;


// import React, { useRef, useState,useEffect } from "react";

// const ImageToVideoCanvas = () => {
//   const [images, setImages] = useState([]);
//   const [videoUrl, setVideoUrl] = useState(null);
//   const canvasRef = useRef(null);
//   const mediaRecorderRef = useRef(null);
//   const chunksRef = useRef([]);
//   const audioContextRef = useRef(new (window.AudioContext || window.webkitAudioContext)());





//   // const handleFileChange = async () => {
//     const imageUrls = [
//       "https://resources.wizztech.us/uploads/inventory/web/c5YJiKfSb8_1271725-1.jpg",
//       "https://resources.wizztech.us/uploads/inventory/web/2CJ9RNgmga_1289149-1.jpg",
//       "https://resources.wizztech.us/uploads/inventory/web/PDzBh7a9rN_23--400x480.png"
//     ];
//     useEffect(() => {
//       const fetchImages = async () => {
//         if (imageUrls.length === 0) return;
  
//         const fetchedImages = await Promise.all(
//           imageUrls.map(async (url) => {
//             const response = await fetch(url);
//             const blob = await response.blob();
//             return new File([blob], url.split("/").pop(), { type: blob.type });
//           })
//         );
  
//         setImages(fetchedImages);
//       };
  
//       fetchImages();
//     }, [imageUrls]);

//     // useEffect(() => {
//     //   if (imageUrls.length > 0) {
//     //     const fetchedImages = await Promise.all(
//     //       imageUrls.map(async (url) => {
//     //         const response = await fetch(url);
//     //         const blob = await response.blob();
//     //         return new File([blob], url.split("/").pop(), { type: blob.type });
//     //       })
//     //     );
//     //     setImages(fetchedImages);
//     //   }
//     // }, [imageUrls]);


   
//   // };
  
//   const fetchAndDecodeAudio = async () => {
//     const response = await fetch(
//       "https://cdn.uppbeat.io/audio-files/ca51760c641519bcff2c32cdf8e83fff/3900208d9f7d807c9ca241fc9e47615f/83a1343e5b8e80fab1e119b15772ee1c/STREAMING-blue-sea-swoop-main-version-18177-01-14.mp3"
//     );
//     const arrayBuffer = await response.arrayBuffer();
//     return audioContextRef.current.decodeAudioData(arrayBuffer);
//   };

//   const generateVideo = async () => {
//     if (images.length === 0) {
//       alert("Please select images first.");
//       return;
//     }

//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext("2d");

//     // Set canvas size
//     canvas.width = 1280;
//     canvas.height = 720;

//     // Capture the canvas stream
//     const videoStream = canvas.captureStream();

//     // Load and decode audio
//     const audioBuffer = await fetchAndDecodeAudio();
//     const source = audioContextRef.current.createBufferSource();
//     source.buffer = audioBuffer;

//     // Create an audio stream
//     const destination = audioContextRef.current.createMediaStreamDestination();
//     source.connect(destination);
//     source.start();

//     // Combine video and audio into one stream
//     const combinedStream = new MediaStream([
//       ...videoStream.getTracks(),
//       ...destination.stream.getTracks(),
//     ]);

//     const recorder = new MediaRecorder(combinedStream);
//     mediaRecorderRef.current = recorder;
//     chunksRef.current = [];

//     recorder.ondataavailable = (e) => chunksRef.current.push(e.data);
//     recorder.onstop = () => {
//       const blob = new Blob(chunksRef.current, { type: "video/mp4" });
//       const url = URL.createObjectURL(blob);
//       setVideoUrl(url);
//     };

//     recorder.start();

//     for (const img of images) {
//       const image = new Image();
//       image.src = URL.createObjectURL(img);
//       await new Promise((resolve) => {
//         image.onload = () => {
//           ctx.clearRect(0, 0, canvas.width, canvas.height);
//           ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
//           setTimeout(resolve, 1000);
//         };
//       });
//     }

//     recorder.stop();
//   };

//   return (
//     <div className="container mt-4">
//       <h2 className="mb-3">Generate Video from Images</h2>
//       {/* <input type="file" multiple accept="image/*" onChange={handleFileChange} className="form-control mb-3" /> */}
//       <button className="btn btn-primary" onClick={generateVideo}>Generate Video</button>

//       <canvas ref={canvasRef} style={{ display: "none" }}></canvas>

//       {videoUrl && (
//         <div className="mt-4">
//           <h4>Generated Video:</h4>
//           <video controls width="640" src={videoUrl}></video>
//           <a href={videoUrl} download="generated-video.mp4" className="btn btn-success mt-2">Download Video</a>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ImageToVideoCanvas;
